export default "/images/f923971f91a9076a91192d7a11d43df2.avif";